/**
 * Settings Type Definitions
 *
 * TypeScript interfaces for WooCommerce AI Chatbot Pro settings
 *
 * @package WooAIChatbot
 */
/**
 * Available AI Models per Provider
 * Updated: April 2026
 */
export const AI_MODELS = {
    gemini: [
        'gemini-3.1-flash-lite-preview', // Latest, feels smarter in practice
        'gemini-2.5-flash', // Stable GA
        'gemini-2.5-flash-lite', // Cheapest
    ],
    openai: [
        'gpt-5-mini', // Smart reasoning model, fast with minimal reasoning_effort
        'gpt-4.1-mini', // Non-reasoning, fast, 1M context
    ],
    claude: [
        'claude-sonnet-4-5-20251101',
        'claude-haiku-4-5-20251101',
    ],
};
/**
 * Human-readable labels for AI models.
 * Falls back to the model ID if no label is defined.
 */
export const MODEL_LABELS = {
    // Gemini
    'gemini-3.1-flash-lite-preview': 'Gemini 3.1 Flash Lite (Latest)',
    'gemini-2.5-flash': 'Gemini 2.5 Flash (Stable)',
    'gemini-2.5-flash-lite': 'Gemini 2.5 Flash Lite (Cheapest)',
    // OpenAI
    'gpt-5-mini': 'GPT-5 Mini (Smart)',
    'gpt-4.1-mini': 'GPT-4.1 Mini (Fast, 1M ctx)',
    // Claude
    'claude-sonnet-4-5-20251101': 'Claude Sonnet 4.5 (Best quality)',
    'claude-haiku-4-5-20251101': 'Claude Haiku 4.5 (Fast)',
};
/**
 * Default Settings
 */
export const DEFAULT_SETTINGS = {
    aiProvider: {
        provider: 'gemini',
        geminiApiKey: '',
        openaiApiKey: '',
        claudeApiKey: '',
        geminiModel: 'gemini-2.5-flash',
        openaiModel: 'gpt-4.1-mini',
        claudeModel: 'claude-sonnet-4-5-20251101',
        temperature: 0.7,
        maxTokens: 2048,
        enableFallback: false,
        fallbackProvider: 'openai',
        fallbackModel: 'gpt-4o',
        enableStreaming: true,
        thinkingEnabled: false,
        thinkingBudget: 512,
    },
    general: {
        sessionTimeout: 30,
        rateLimitPerMinute: 60,
        cacheTtl: 3600,
        debugMode: false,
        logLevel: 'info',
    },
    appearance: {
        widgetPosition: 'bottom-right',
        primaryColor: '#6366F1',
        secondaryColor: '#4F46E5',
        accentColor: '#10B981',
        textColor: '#111827',
        widgetBackground: '#FFFFFF',
        cardBackground: '#FFFFFF',
        cardTextColor: '#111827',
        fontFamily: 'Inter (Default)',
        fontSizeScale: 'Medium (Default)',
        widgetSize: 'medium',
        showGreeting: true,
        greetingMessage: 'Welcome! How can I help you today?',
        widgetWidth: 380,
        maxHeight: 600,
        botAvatar: '🤖',
        botName: 'AI Assistant',
        showRating: true,
        showViewProductButton: true,
        cardBorderRadius: 16,
        cardShadow: 'medium',
        customCSS: '',
        sidebarEnabled: true,
        sidebarSide: 'right',
        sidebarWidth: 30,
    },
    languages: {
        default: 'en',
        enabled: ['en'],
        autoDetect: true,
    },
    rag: {
        enabled: false,
        embeddingModel: 'gemini-embedding-001',
        chunkSize: 500,
        chunkOverlap: 100,
        topK: 5,
        similarityThreshold: 0.7,
        supabaseUrl: '',
        supabaseApiKey: '',
        supabaseTableName: 'product_embeddings',
        supabaseConnectionString: '',
        indexPages: false,
        indexPosts: false,
    },
    whatsapp: {
        enabled: false,
        phone: '',
        buttonText: '',
        includeContext: true,
        escalationTurns: 5,
    },
};
